"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hslToHex = void 0;
var hsl_to_rgb_1 = require("./hsl-to-rgb");
var rgb_to_hex_1 = require("./rgb-to-hex");
var hslToHex = function (hsl) { return (0, rgb_to_hex_1.rgbToHex)((0, hsl_to_rgb_1.hslToRgb)(hsl)); };
exports.hslToHex = hslToHex;
